import { Component, OnInit } from '@angular/core';
import { LicenseAppModule, LicenseService } from '@shared/services/license.service';
import { UserService } from '@shared/services/user.service';
import { map } from 'rxjs/operators';
import { SideMenuItem } from './models/side-menu-item.model';

@Component({
  selector: 'pop-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.less']
})
export class SideMenuComponent implements OnInit {
  public mainMenuSections: SideMenuItem[];
  public secondaryMenuSections: SideMenuItem[];

  public constructor(private licenseService: LicenseService, private userService: UserService) {}

  public ngOnInit(): void {
    this.mainMenuSections = [
      new SideMenuItem({
        mainIconClass: 'far fa-house',
        titleKey: 'BUTTON.HOME',
        route: ['welcome']
      }),
      new SideMenuItem({
        titleKey: 'BUTTON.ESTIMATE_LIST',
        mainIconClass: 'far fa-chart-bar',
        route: ['estimate-list'],
        $isHidden: this.licenseService
          .isUserAllowedToAccessModule(LicenseAppModule.Estimation)
          .pipe(map(isAllowed => !isAllowed))
      })
    ];

    this.secondaryMenuSections = [
      new SideMenuItem({
        titleKey: 'BUTTON.ADMIN',
        mainIconClass: 'fas fa-id-card-alt',
        $isHidden: this.userService.hasRole('app-admin').pipe(map(hasRole => !hasRole)),
        isExpanded: false,
        children: [
          new SideMenuItem({
            mainIconClass: 'fas fa-sync',
            titleKey: 'BUTTON.DATAMANAGEMENT',
            route: ['data-management']
          }),
          new SideMenuItem({
            mainIconClass: 'fas fa-cog',
            titleKey: 'BUTTON.SETTINGS',
            route: ['settings-management']
          })
        ]
      })
    ];
  }
}
